import styled from "styled-components";

export const Container = styled.li`
    border: 1px solid black;

    border-radius: 5px;

    display: flex;
    flex-direction: column;

    margin: 1em;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;

    justify-content: space-between;

    padding: 5px;

    font-size: 18px;

`;

export const Content = styled.div`

    margin: 5px;

    border: 1px solid black;

    font-size: 16px;

    > textarea {
        /* margin: 10px 10px 10px 10px; */
        border: none;
        width: calc(100% - 5px);
        min-height: 100px;

        /* overflow-y: scroll; */
        /* margin-left: 10px; */
        /* margin-top: 10px; */
    }
`;
